import React from "react";
import { AccordionItem } from "../../Elements/Accordion";
import { Checkbox } from "../../Elements/Checkbox";

export const AttachDrawing = ({
    onChange,
    defaultChecked
}: {
    onChange: CallableFunction;
    defaultChecked: boolean;
}): JSX.Element => {
    return (
        <AccordionItem title="Pielikumi" changeHeight={Date.now()} key="attach drawing">
            <div className="attach-drawing-checkbox">
                <Checkbox
                    label={
                        "Pasākuma maršruta dati GPX, KML vai citā datu formā tiks pievienoti kā pielikums pieteikuma pēdējā solī"
                    }
                    defaultChecked={defaultChecked}
                    onChange={(checked) => onChange(checked)}
                ></Checkbox>
            </div>
        </AccordionItem>
    );
};
